import { useState, useEffect } from 'react';

const BREAKPOINTS = {
    base: 0,
    sm: 768,
    md: 1024,
    lg: 1280,
};
const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: 0,
        height: 0,
        breakpoint: "base",
    });
    useEffect(() => {
        const handleResize = () => {
            const breakpoint = Object.keys(BREAKPOINTS).reduce((acc, cur) => (window.innerWidth >= BREAKPOINTS[cur] ? cur : acc), "base");
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                breakpoint,
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};

export { useWindowSize as default };
//# sourceMappingURL=index.js.map
